import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_FAMILLE_SCHEMA_LITERAL = {
    title: 'Schéma Familles',
    description: 'Décrit une famille d\'articles',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        USER_ID: { type: 'string' },
        SITEGID: { type: 'string' },
        FA_CODEFAMILLE: { type: 'string' },
        FA_INTITULE: { type: 'string' },
        FA_TYPE: { type: 'number' },
        FA_UNITEVEN: { type: 'number' },
        FA_COEF: { type: 'number' },
        FA_SUIVISTOCK: { type: 'number' },
        FA_GARANTIE: { type: 'number' },
        FA_CENTRAL: { type: 'string' },
        FA_CODEFISCAL: { type: 'string' },
        FA_PAYS: { type: 'string' },
        FA_UNITEPOIDS: { type: 'number' },
        FA_ESCOMPTE: { type: 'number' },
        FA_DELAI: { type: 'number' },
        FA_HORSSTAT: { type: 'number' },
        FA_VTEDEBIT: { type: 'number' },
        FA_NOTIMP: { type: 'number' },
    },
    required: [ 'CBMARQ' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_FAMILLE_SCHEMA_LITERAL);
export type RxFFamilleDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_FAMILLE_SCHEMA: RxJsonSchema<RxFFamilleDocumentType> = F_FAMILLE_SCHEMA_LITERAL;
